import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  ArrowRightCircle,
  Envelope,
} from "react-bootstrap-icons";

const formInitialDetails = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  message: "",
};

export const Contact = () => {
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState({});

  const onFormUpdate = (category, value) => {
    setFormDetails((currentDetails) => ({
      ...currentDetails,
      [category]: value,
    }));

    if (status.message) {
      setStatus({});
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setStatus({});

    try {
      const response = await fetch(
        "https://webkristal.onrender.com/contact",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify(formDetails),
        }
      );

      const result = await response.json();

      if (!response.ok || Number(result.code) !== 200) {
        throw new Error("Message could not be sent.");
      }

      setFormDetails(formInitialDetails);
      setStatus({
        success: true,
        message: "Message sent successfully.",
      });
    } catch (error) {
      setStatus({
        success: false,
        message: "Something went wrong. Please try again later.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section
      className="contact contact-modern"
      id="connect"
      aria-labelledby="contact-title"
    >
      <Container>

        {/* SECTION HEADING */}
        <div className="contact-modern__heading">
          <div>
            <span className="contact-modern__eyebrow">
              START A CONVERSATION
            </span>

            <h2 id="contact-title">Get In Touch</h2>

            <p>
              Tell us about your imaging, electro-optical or FPGA development
              requirements. Our engineering team will get back to you.
            </p>
          </div>

          <a
            className="contact-modern__email"
            href="mailto:info@kristalfotonik.com"
          >
            <Envelope aria-hidden="true" />

            <span>
              <small>DIRECT EMAIL</small>
              info@kristalfotonik.com
            </span>
          </a>
        </div>

        {/* FORM PANEL */}
        <div className="contact-modern__form-panel">
          <form onSubmit={handleSubmit}>
            <Row className="g-3">

              <Col xs={12} md={6}>
                <div className="contact-modern__field">
                  <label htmlFor="contact-first-name">
                    First Name
                  </label>

                  <input
                    id="contact-first-name"
                    type="text"
                    value={formDetails.firstName}
                    placeholder="Your first name"
                    autoComplete="given-name"
                    required
                    onChange={(event) =>
                      onFormUpdate("firstName", event.target.value)
                    }
                  />
                </div>
              </Col>

              <Col xs={12} md={6}>
                <div className="contact-modern__field">
                  <label htmlFor="contact-last-name">
                    Last Name
                  </label>

                  <input
                    id="contact-last-name"
                    type="text"
                    value={formDetails.lastName}
                    placeholder="Your last name"
                    autoComplete="family-name"
                    required
                    onChange={(event) =>
                      onFormUpdate("lastName", event.target.value)
                    }
                  />
                </div>
              </Col>

              <Col xs={12} md={6}>
                <div className="contact-modern__field">
                  <label htmlFor="contact-email">
                    Email Address
                  </label>

                  <input
                    id="contact-email"
                    type="email"
                    value={formDetails.email}
                    placeholder="name@company.com"
                    autoComplete="email"
                    required
                    onChange={(event) =>
                      onFormUpdate("email", event.target.value)
                    }
                  />
                </div>
              </Col>

              <Col xs={12} md={6}>
                <div className="contact-modern__field">
                  <label htmlFor="contact-phone">
                    Phone Number
                    <span>Optional</span>
                  </label>

                  <input
                    id="contact-phone"
                    type="tel"
                    value={formDetails.phone}
                    placeholder="+90"
                    autoComplete="tel"
                    onChange={(event) =>
                      onFormUpdate("phone", event.target.value)
                    }
                  />
                </div>
              </Col>

              <Col xs={12}>
                <div className="contact-modern__field">
                  <label htmlFor="contact-message">
                    Message
                  </label>

                  <textarea
                    id="contact-message"
                    rows="6"
                    value={formDetails.message}
                    placeholder="Tell us briefly about your requirements..."
                    required
                    onChange={(event) =>
                      onFormUpdate("message", event.target.value)
                    }
                  />
                </div>
              </Col>

              <Col xs={12}>
                <div className="contact-modern__footer">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                  >
                    <span>
                      {isSubmitting ? "Sending..." : "Send Message"}
                    </span>

                    <ArrowRightCircle aria-hidden="true" />
                  </button>

                  {status.message && (
                    <p
                      className={
                        status.success
                          ? "contact-modern__status contact-modern__status--success"
                          : "contact-modern__status contact-modern__status--error"
                      }
                      role={status.success ? "status" : "alert"}
                    >
                      {status.message}
                    </p>
                  )}
                </div>
              </Col>

            </Row>
          </form>
        </div>

      </Container>
    </section>
  );
};